import Handler from "../Handler";
class RITRequestHandler extends Handler {
    execute(message) {
      let receivedData = JSON.parse(message);
      this.service.processRITRequest(receivedData);
    }
  }
  
  export default RITRequestHandler;